import React, { Component } from 'react'
// import "./NonPoItems.css";
import SideNav from '../sidenav/Sidenav.js'
import { CrfContext } from '../../CrfContext'
import { Redirect } from 'react-router-dom'

import { Transition, animated } from 'react-spring/renderprops'
import { getData, localValidation, allowNumberInputs } from './actions'
import DraftView from './DraftView'

import axios from 'axios'
import PoModal from '../poitems/PoModal.js'
// import NonPoModal from "./NonPoModal";

export class NonPoItems extends Component {
  state = {
    userDeptList: [],
    isLoading: false,
    dueDate: '',

    projectClassAdvances: [],
    projectClassCocExpenses: [],

    showBanner: true,
    showForm: false,
    showPage1: false,
    showPage2: false,

    requestType: '',
    vendor: '',
    vendorError: false,
    vendorErr: 1,
    particulars: '',
    particularsError: false,
    particularsErr: 1,
    requestingDepartment: '',
    poNumber: null,
    poNumberError: false,
    poNumberErr: 1,
    project: '',
    projectError: false,
    projectErr: 1,
    subProject: '',
    file: null,
    fileText: null,
    fileError: false,
    fileErr: 1,

    projectClass: [
      {
        glCategory: '',
        glAccount: '',
        description1: '',
        description2: '',
        itemNumber: '',
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: '1OV',
        vatType: 'NON-VAT',
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: 'X1',
        wTaxTypeValue: 0,
        wTaxTypeString: '',
        unitPrice: 0,
        subNetPrice: 0,
        projectClass: '',
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0
      }
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0,
    glCategory: '',
    projectCode: '',
    vendorLists: [],
    departmentLists: [],
    projectLists: [],
    projectCode: '',
    accountTypes: [],
    itemNoList: [],

    redirect: false,
    crfId: '',

    vendorListEmpty: false,
    updateForm: false,
    advancesProjectClass: [],

    subNetList: [],

    vatTypeSelector: '',
    vatTypeSelected: '',

    wTaxRates: [],

    vendorLists: [],
    projectLists: [],

    opex: [],
    cocExpenses: [],
    advances: [],
    ppeAccounts: [],
    adminExpenses: [],
    advancesProjectClass: [],

    error: 0,

    removal: false,
    target: null,
    addProjectClass: false,

    requestId: ''
  }

  onBlurNumber = (e, index, key) => {
    if (key === 'quantity') {
      const projectClass = [...this.state.projectClass]
      const obj = { ...projectClass[index] }
      if (e.target.value === '0' || e.target.value === '') {
        obj[key] = 1
        projectClass[index] = obj
        this.setState({
          projectClass
        })
        return
      }
    }

    if (key === 'grossPricePerItem') {
      const projectClass = [...this.state.projectClass]
      const obj = { ...projectClass[index] }
      if (e.target.value === '') {
        obj[key] = 0
        projectClass[index] = obj
        this.setState({
          projectClass
        })
        return
      }
    }
  }

  handleWTaxRate = async wTaxType => {
    const { data } = await getData(`/api/withHoldingTax/wTaxRate/${wTaxType}`)
    return data.rate
  }
  projectClassComputation = async (
    qty,
    grossPrice,
    vatType,
    wTaxType,
    projectClass,
    index,
    key
  ) => {
    const data = {
      rate: projectClass[index].wTaxRate
    }
    if (key === 'wTaxType') {
      data.rate = await this.handleWTaxRate(wTaxType)
    }
    const subTotalGrossPrice =
      (qty === '' ? 1 : parseInt(qty)) *
      parseFloat(grossPrice === '' ? 0 : grossPrice)
    const unitPrice =
      subTotalGrossPrice /
      (vatType === 'VAT-X' ||
      vatType === 'VAT-Z' ||
      vatType === 'NON-VAT' ||
      vatType === 'INT-IV'
        ? 1
        : 1.12)
    const netVat = subTotalGrossPrice - unitPrice
    const netWTax = unitPrice * (data.rate * 0.01)
    const subTotalNetPrice = subTotalGrossPrice - netWTax
    projectClass[index].quantity = qty
    projectClass[index].grossPricePerItem = grossPrice
    projectClass[index].vatType = vatType
    projectClass[index].wTaxCode = wTaxType
    projectClass[index].wTaxType = wTaxType
    projectClass[index].wTaxRate = data.rate
    projectClass[index].subTotalGrossPrice = subTotalGrossPrice.toFixed(2)
    projectClass[index].subTotalNetPrice =
      data.rate === '0'
        ? subTotalGrossPrice.toFixed(2)
        : subTotalNetPrice.toFixed(2)

    let requestingGrossPrice = 0.0
    let requestingAmount = 0.0

    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice)
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount)
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2)
    })
  }

  onChangedHandler = (event, index, key) => {
    if (key === 'poNumber') {
      if (event.target.value.length <= 9) {
        const poNumber = allowNumberInputs(event.target.value)
        this.setState({
          poNumber
        })
      }
      return
    }
    if (key === 'dueDate') {
      this.setState({
        dueDate: event.target.value
      })
    }
    if (key === 'quantity') {
      const projectClass = [...this.state.projectClass]
      const obj = { ...projectClass[index] }
      if (event.target.value === '0' || event.target.value === ' ') {
        obj.quantity = ''
      } else {
        if (event.target.value.length > 9) {
          const qtyCopy = event.target.value.slice(0, -1)
          const quantity = allowNumberInputs(qtyCopy)
        } else {
          const quantity = allowNumberInputs(event.target.value)
          this.projectClassComputation(
            quantity.trim(),
            this.state.projectClass[index].grossPricePerItem,
            this.state.projectClass[index].vatType,
            this.state.projectClass[index].wTaxCode,
            projectClass,
            index,
            'quantity'
          )
        }
      }
    }

    this.handleChangeProjectClassValue(event, index, key)
    const projectClassArray = [...this.state.projectClass]
    const projectClassObject = { ...projectClassArray[index] }
    projectClassArray[index] = projectClassObject
    this.setState({
      projectClass: projectClassArray
    })
  }

  componentDidMount () {
    setTimeout(() => {
      this.setState({
        showForm: true
      })
    }, 500)

    // this.setState({
    //   requestId: this.props.match.params.id
    // })

    // === INITIAL VALUE OF DRAFT ==============================================================================================

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/${this.props.crfId}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(async response => {
        console.log(response.data.data)
        const data = response.data.data
        const fileText = data.supportingDocuments
          ? data.supportingDocuments
          : null

        let requestingGrossPrice = 0.0
        let requestingAmount = 0.0
        for (let obj of data.projectClasses) {
          const glAccountCopy = { ...obj.glAccount }
          obj.glCategory = glAccountCopy.accountType
          obj.glAccount = `${glAccountCopy.accountCode} ${glAccountCopy.accountName} ${glAccountCopy.centerCode}`
          obj.projectClass = glAccountCopy.centerName
          obj.wTaxType = obj.wTaxCode
          obj.wTaxRate = await this.handleWTaxRate(obj.wTaxCode)
          obj.subTotalGrossPrice = parseFloat(
            obj.apv.subTotalGrossPrice
          ).toFixed(2)
          obj.subTotalNetPrice = parseFloat(obj.apv.subTotalNetPrice).toFixed(2)

          requestingGrossPrice =
            parseFloat(obj.apv.subTotalGrossPrice) +
            parseFloat(requestingGrossPrice)
          requestingAmount =
            parseFloat(obj.apv.subTotalNetPrice) + parseFloat(requestingAmount)
        }
        this.setState({
          requestId: data._id,
          requestType: response.data.data.requestType,
          projectClass: data.projectClasses,
          requestingGrossPrice: requestingGrossPrice.toFixed(2),
          requestingAmount: requestingAmount.toFixed(2),
          fileText
        })
        console.log(data)
        if (data.poNumber) {
          this.setState({
            poNumber: data.poNumber
          })
        }

        if (data.department) {
          this.setState({
            requestingDepartment: response.data.data.department.centerName
          })
        }

        if (data.dueDate) {
          this.setState({
            dueDate: response.data.data.dueDate
          })
        }

        if (data.vendor) {
          this.setState({ vendor: data.vendor.bpName })

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/vendors/${data.vendor.bpName}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response.data.data.bpCode)
              this.setState({
                vatTypeSelector: response.data.data.vatType
              })
              // ==================================================================================
              // VENDOR BP CODE WILL GET THE WTAX

              axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                  console.log(response)
                  let newArray = response.data.data
                  const none = {
                    wTaxCode: 'X1',
                    wTaxName: '',
                    wTaxDisplayName: 'None X1',
                    rate: '0'
                  }
                  newArray.push(none)
                  this.setState({
                    wTaxRates: response.data.data
                  })
                  console.log(this.state.wTaxRates)
                })
                .catch(error => {
                  console.log(error.response)
                })

              // ==================================================================================
            })
            .catch(error => {
              console.log(error.response)
            })
        }

        if (data.particulars) {
          this.setState({ particulars: data.particulars })
        }

        if (data.project) {
          if (data.project) {
            this.setState({ project: data.project.projectName })
          } else {
            this.setState({ project: data.project.projectName })
          }

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/projects/${data.project.projectName}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              this.setState({
                projectCode: response.data.data.projectCode
              })
              console.log(this.state.projectCode)

              // GET THE GLNAME
              axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                  console.log(response)
                  this.setState({
                    accountTypes: response.data.data
                  })
                  console.log(this.state.accountTypes)
                })
                .catch(error => {
                  console.log(error.response)
                  this.setState({
                    accountTypes: []
                  })
                })
            })
            .catch(error => {
              console.log(error.response)
            })
        }

        if (data.subProject) {
          this.setState({ subProject: data.subProject })
        }

        console.log(data.projectClasses)
        // if(data.projectClass){
        //   if(data.projectClasses.length !==0){
        this.setState({
          projectClass: data.projectClasses
        })

        //   }else{
        //     this.setState({
        //       projectClass: data.projectClass
        //     })

        //   }
        // }

        console.log(data.projectClasses)
      })
      .catch(error => {
        console.log(error.response)
      })

    // ==== END OF INITIAL VALUE ==================================================================================================
    // ===================================================================
    // GET VENDOR LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // document.getElementById('main').style.display = 'block'
        console.log(response)
        this.setState({
          vendorLists: response.data.data
        })
        console.log(this.state.vendorLists)
      })
      .catch(error => {
        console.log(error.response)
      })

    //================================================================================

    // GET PROJECT LIST
    // axios({
    //   method: 'GET',
    //   url: `${process.env.REACT_APP_API_KEY}/api/projects`,
    //   headers: {
    //     'Api-Key':
    //       '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
    //     Authorization: `Bearer ${localStorage.token}`
    //   }
    // })
    //   .then(response => {
    //     console.log(response)
    //     this.setState({
    //       projectLists: response.data.data
    //     })
    //   })
    //   .catch(error => {
    //     console.log(error.response)
    //   })
    // =========================================================

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.data.isProject) {
          const projectsArray = []
          for (const obj of response.data.data.projects) {
            projectsArray.push(obj.projectName)
          }
          this.setState({
            userDeptList: response.data.data.departments,
            projectLists: projectsArray
          })
        } else {
          this.setState({
            userDeptList: response.data.data.departments
          })
          this.loadProjects()
        }
        // this.setState({
        //   // userRole: response.data.data.roles[0],
        //   // userName: response.data.data.firstName
        //   //  + " " + response.data.data.lastName,
        //   // userId: response.data.data._id
        //   userDeptList: response.data.data.departments
        // })
      })
      .catch(error => {
        console.log(error.response)
      })

    // ============================================================================
    // GET COC EXPENSES
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/COC Expenses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response.data.data[0].accountName)
        let cocExpenses = []
        for (let i = 0; i < response.data.data.length; i++) {
          cocExpenses.push(
            response.data.data[i].accountCode +
              ' ' +
              response.data.data[i].accountName +
              ' ' +
              response.data.data[i].centerCode
          )
        }

        this.setState({
          cocExpenses: cocExpenses,
          projectClassCocExpenses: response.data.data
        })
        // console.log(this.state.cocExpenses)
      })
      .catch(error => {
        console.log(error.response)
      })

    // ======================================================================================
    // GET ADVANCES LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Advances`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response)
        let advances = []
        for (let i = 0; i < response.data.data.length; i++) {
          advances.push(
            response.data.data[i].accountCode +
              ' ' +
              response.data.data[i].accountName +
              ' ' +
              response.data.data[i].centerCode
          )
        }
        this.setState({
          advances: advances,
          projectClassAdvances: response.data.data
        })
        // console.log(this.state.advances)
      })
      .catch(error => {
        // console.log(error.response)
      })

    // ===============================================================================
    // GET PPE ACCOUNT LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/PPE Accounts`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        let ppeAccount = []
        for (let i = 0; i < response.data.data.length; i++) {
          ppeAccount.push(
            response.data.data[i].accountCode +
              ' ' +
              response.data.data[i].accountName +
              ' ' +
              response.data.data[i].centerCode
          )
        }
        this.setState({
          ppeAccounts: ppeAccount
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    // ========================================================================================
    //  GET ADMIN EXPENSES

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Admin Expenses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response)
        let adminExpenses = []
        for (let i = 0; i < response.data.data.length; i++) {
          adminExpenses.push(
            response.data.data[i].accountCode +
              ' ' +
              response.data.data[i].accountName +
              ' ' +
              response.data.data[i].centerCode
          )
        }
        this.setState({
          adminExpenses: adminExpenses
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    //=========================================================================================

    //  GET OPEX
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/OPEX`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        let opex = []
        for (let i = 0; i < response.data.data.length; i++) {
          opex.push(
            response.data.data[i].accountCode +
              ' ' +
              response.data.data[i].accountName +
              ' ' +
              response.data.data[i].centerCode
          )
        }
        this.setState({
          opex
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    //=========================================================================================

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projectClasses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          advancesProjectClass: response.data.data
        })
        console.log(this.state.advancesProjectClass)
      })
      .catch(error => {
        console.log(error.response)
      })

    // =========================================================================================
  }

  loadProjects = () => {
    // GET PROJECT LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projects`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          projectLists: response.data.data
        })
      })
      .catch(error => {
        console.log(error.response)
      })
    // =========================================================
  }

  checkStateValue = e => {
    e.preventDefault()
    console.log(this.state)
  }

  // END OF COMPONENT DID MOUNT
  handleChangeRequestField = e => {
    e.preventDefault()
    if (e.target.name === 'vendor') {
      this.setState({ vendorError: true })
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response.data.data.bpCode)
          this.setState({
            vatTypeSelector: response.data.data.vatType
          })
          // ==================================================================================
          // VENDOR BP CODE WILL GET THE WTAX

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              let newArray = response.data.data
              const none = {
                wTaxCode: 'X1',
                wTaxName: '',
                wTaxDisplayName: 'None ',
                rate: '0'
              }
              newArray.push(none)
              this.setState({
                wTaxRates: newArray
              })
              console.log(this.state.wTaxRates)
            })
            .catch(error => {
              console.log(error.response)
            })

          // ==================================================================================
        })
        .catch(error => {
          console.log(error.response)
        })

      if (
        !this.state.vendorLists.includes(
          document.getElementById(`${e.target.id}`).value
        )
      ) {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText =
          'Invalid Input'
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText =
          ' ' + '(Please input a valid data included in the list)'
        this.setState({ vendorErr: 1 })
      } else {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = ''
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = ''
        this.setState({ vendorErr: 0 })
      }

      const newProjecClasses = this.state.projectClass
      for (let i = 0; i < newProjecClasses.length; i++) {
        console.log(this.state.wTaxRates)
        if (this.state.wTaxRates.length === 1) {
          newProjecClasses[i].wTaxType = 'X1'
        } else {
          newProjecClasses[i].vatType = ''
          newProjecClasses[i].wTaxType = ''
        }

        document.getElementsByClassName('vatTypeInitialValue')[i].innerText =
          'Please Choose'
        //  document.getElementsByClassName('wTaxInitialValue')[i].innerText = "Please Choose..."
        //  document.getElementsByClassName('wTaxInitialValue')[i].setAttribute("selected", "")
        //  document.getElementsByClassName('wTaxInitialValue')[i].setAttribute("hidden", "")
        //  document.getElementsByClassName('wTaxInitialValue')[i].setAttribute("disabled", "")
      }

      this.setState({
        projectClass: newProjecClasses
      })
    }

    if (e.target.name === 'particulars') {
      this.setState({ particularsError: true })
      if (e.target.value === '') {
        this.setState({ particularsErr: 1 })
      } else {
        this.setState({ particularsErr: 0 })
      }
    }

    if (e.target.name === 'project') {
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.setState(() => (this.state.projectClass[i].glCategory = ''))
      }
      // ================================================================================================
      this.setState({ projectError: true, projectErr: 1 })
      if (
        !this.state.projectLists.includes(
          document.getElementById(`${e.target.id}`).value
        )
      ) {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText =
          'Invalid Input'
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText =
          ' ' + '(Please input a valid data included in the list)'
        this.setState({ projectErr: 1 })
      } else {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = ''
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = ''
        this.setState({ projectErr: 0 })
      }

      if (e.target.value === '') {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = ''
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = ''
        this.setState({ projectErr: 1 })
      }

      // =======================================================
    }

    if (e.target.name === 'file' && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split('.')
      let fileExtension = fileName[fileName.length - 1]
      this.setState({ fileError: true })
      console.log(e.target.file)
      console.log(fileExtension)
      if (fileExtension !== 'pdf') {
        this.setState({ fileErr: 1 })
        console.log('error')
      } else {
        this.setState({ fileErr: 0 })
        console.log('success')
      }
    }

    if (e.target.name === 'file' && e.target.files.length === 0) {
      this.setState({ fileErr: 1 })
    }

    // GET THE PARTICULAR VAT TYPE FOR SELECTED VENDOR

    // ================================================================

    // this.setState({
    //   [e.target.name]: e.target.value,
    //   requestingDepartment: document.getElementById("departmentInput").value
    // })
    // this.setState(()=> this.state.(e.target.name) = e.target.value)

    // CHANGE GL CATEGORY SELECTIONS
    // for (let i = 0; i < glCategoryClass.length; i++) {
    //   console.log('test')
    //   glCategoryClass[i].value = ""
    //   this.setState(()=> this.state.projectClass[i].glCategory = "")
    // }

    if (e.target.name === 'project') {
      this.setState({
        accountTypes: []
      })
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
            projectCode: response.data.data.projectCode
          })
          console.log(this.state.projectCode)

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              this.setState({
                accountTypes: response.data.data
              })
              console.log(this.state.accountTypes)
            })
            .catch(error => {
              console.log(error.response)
              this.setState({
                accountTypes: []
              })
            })
        })
        .catch(error => {
          console.log(error.response)
        })
    }

    if (e.target.name === 'file' && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split('.')
      let fileExtension = fileName[fileName.length - 1]
      fileExtension !== 'pdf'
        ? (document.getElementById('documentEmptyError').innerText =
            '(Please upload a valid file(pdf).)')
        : (document.getElementById('documentEmptyError').innerText = '')
    }

    let file = null
    if (e.target.name === 'file') {
      console.log(e.target.files[0])
      file = e.target.files[0]
      console.log(file)
      this.setState({
        [e.target.name]: e.target.files[0]
      })
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
    console.log(this.state.accountTypes)

    this.setState({
      error:
        this.state.vendorErr +
        this.state.particularsErr +
        this.state.projectErr +
        this.state.fileErr
    })
    console.log(this.state)
  }

  // =============================

  handleChangeProjectClassValue = (e, index, key) => {
    let projectClassCopy = [...this.state.projectClass]
    if (key === 'customizeProjectClass') {
      projectClassCopy[parseInt(e.target.id)]['projectClass'] = e.target.value
      if (index) {
        projectClassCopy[parseInt(e.target.id)][
          'glAccount'
        ] = `${index.accountCode} ${index.accountName} ${index.centerCode}`
      } else {
        projectClassCopy[parseInt(e.target.id)]['glAccount'] = ''
      }
      this.setState({ projectClass: projectClassCopy })
      return
    }
    if (
      e.target.name === 'glCategory' ||
      e.target.name === 'glAccount' ||
      e.target.name === 'projectClass' ||
      e.target.name === 'itemCode'
    ) {
      projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value
      this.setState({ projectClass: projectClassCopy })
    }
    if (key === 'description1' || key === 'description2') {
      projectClassCopy[index][key] = e.target.value.trimLeft()
      this.setState({ projectClass: projectClassCopy })
    }
    if (key === 'itemCode') {
      projectClassCopy[index][key] = e.target.value.trimRight()
      this.setState({ projectClass: projectClassCopy })
    }
    if (e.target.name === 'grossPricePerItem') {
      const grossPrice = e.target.value.split('.')
      if (grossPrice[0].length <= 12) {
        // projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value
        // this.setState({projectClass: projectClassCopy})
        this.projectClassComputation(
          this.state.projectClass[index].quantity,
          e.target.value,
          this.state.projectClass[index].vatType,
          this.state.projectClass[index].wTaxCode,
          projectClassCopy,
          index,
          'grossPricePerItem'
        )
      }
    }
    if (e.target.name === 'vatType') {
      this.projectClassComputation(
        this.state.projectClass[index].quantity,
        this.state.projectClass[index].grossPricePerItem,
        e.target.value,
        this.state.projectClass[index].wTaxCode,
        projectClassCopy,
        index,
        'vatType'
      )
    }

    if (e.target.name === 'wTaxType') {
      this.projectClassComputation(
        this.state.projectClass[index].quantity,
        this.state.projectClass[index].grossPricePerItem,
        this.state.projectClass[index].vatType,
        e.target.value,
        projectClassCopy,
        index,
        'wTaxType'
      )
    }

    // EXTRACT GL ACCOUNT NAME
    // let glAccountValue = ''
    // if (e.target.name === 'glAccount') {
    //   glAccountValue = e.target.value
    //   console.log(glAccountValue.substring(0, 10))
    //   projectClassCopy[
    //     parseInt(e.target.id)
    //   ].glAccount = glAccountValue.substring(0, 10)
    //   console.log(this.state.projectClass)
    //   this.setState({ projectClass: projectClassCopy })
    // }

    // CHANGE GL NAME LISTS
    if (e.target.value === 'COC Expenses') {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'cocExpenses'
        )
    }

    if (e.target.value === 'Advances') {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute('list', 'advances')
    }

    if (e.target.value === 'Admin Expenses') {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'adminExpenses'
        )
    }

    if (e.target.value === 'PPE Accounts') {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'ppeAccounts'
        )
    }

    if (e.target.value === 'OPEX') {
      document
        .getElementById(`${parseInt(e.target.id)}`)
        .nextElementSibling.nextElementSibling.setAttribute('list', 'opex')
    }

    if (e.target.name === 'glCategory') {
      e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.value =
        ''
      document.getElementById(
        `${parseInt(e.target.id)}`
      ).nextElementSibling.nextElementSibling.value = ''
      projectClassCopy[parseInt(e.target.id)].glAccount = ''
      projectClassCopy[parseInt(e.target.id)].projectClass = ''
      // CHANGE PROJECT CLASS LOOP
      // for (let i = 0; i < projectClassCopy.length; i++) {
      //   console.log('test')
      //   projectClassCopy[i].glAccount = ""
      // }
      this.setState({ projectClass: projectClassCopy })
    }
    if (e.target.name === 'glCategory' && e.target.value === 'Advances') {
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'block'
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'block'
    } else if (
      e.target.name === 'glCategory' &&
      e.target.value !== 'Advances'
    ) {
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'none'
      // e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
      //   'none'
      // console.log(e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling)
    }
  }

  addProjectClass = e => {
    e.preventDefault()
    this.setState({
      addedProjectClass: true,
      projectClass: [
        ...this.state.projectClass,
        {
          glCategory: '',
          glAccount: '',
          description1: '',
          description2: '',
          itemNumber: '',
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: '1OV',
          vatType: 'NON-VAT',
          vatTypeValue: 1,
          wTax: 0,
          wTaxCode: 'X1',
          wTaxType: 'X1',
          wTaxRate: '0',
          wTaxTypeValue: 0,
          wTaxTypeString: '',
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: '',
          subTotalGrossPrice: 0.0,
          subTotalNetPrice: 0.0
        }
      ]
    })
    // this.state.projectClass.push(
    //   {
    //           glCategory: "",
    //           glAccount: "",
    //           description1: "",
    //           description2: "",
    //           itemNumber: "",
    //           grossPricePerItem: 0,
    //           netPricePerItem: 0,
    //           quantity: 1,
    //           costType: "1OV",
    //           vatType: "",
    //           vatTypeValue: 1,
    //           wTax: 0,
    //           wTaxType:"X1",
    //           wTaxTypeValue: 0,
    //           wTaxTypeString: "",
    //           unitPrice: 0,
    //           subNetPrice: 0,
    //           projectClass: ""
    //         }
    // )
  }

  handleSubmitNonPo = e => {
    console.log(document.getElementById('formHintContainer'))
    if (this.state.requestType === 'PO Item') {
      if (this.state.poNumber === null || this.state.poNumber === '') {
        document.getElementById('formHintContainer').style.display = 'block'
      }
    }
    e.preventDefault()
    // document.getElementById('modalBody').style.display = 'block';
    document.getElementById('page1').style.display = 'block'
    let array = this.state.projectClass

    let formData = new FormData()

    let nonPoForm = {
      department: this.state.requestingDepartment,
      departmentApprover: '5def0fc26501e01d3c1b3b45',
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,
      // dueDate: this.state.dateNeeded,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: 'Non PO Item',
      status: 'For Approval',
      unitPrice: this.state.unitPrice
    }

    formData.set('crfForm', JSON.stringify(nonPoForm))
    formData.append('supportingDocuments', this.state.file)

    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        console.log(response.data.Data._id)
        this.setState({
          redirect: true,
          crfId: `/CheckRequest/${response.data.Data._id}`
        })
        document.getElementById('modalBody').style.display = 'none'
        console.log(this.state.redirect)
      })
      .catch(error => {
        console.log(error.response)
        // document.getElementById("form-validation-error").innerText = "Please fill out the required fields or check if your input is correct"
      })
  }

  handleDraftNonPo = e => {
    console.log(this.state.requestType)

    e.preventDefault()
    console.log('this is the testing line breakpoint')
    console.log(this.state.projectClass)
    let array = this.state.projectClass
    let formData = new FormData()
    const newProjectClass = []

    let nonPoForm = {
      poNumber: this.state.poNumber,
      vendor: this.state.vendor,
      department: this.state.requestingDepartment,
      particulars: this.state.particulars,
      project: this.state.project,
      subProject: this.state.subProject,
      projectClasses: this.state.projectClass,
      requestingGrossPrice: this.state.requestingGrossPrice,
      requestingAmount: this.state.requestingAmount
    }

    console.log(nonPoForm)

    formData.set('crfForm', JSON.stringify(nonPoForm))
    formData.append('supportingDocuments', this.state.file)

    document.getElementById('modalBody').style.display = 'block'
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/draft/${this.props.crfId}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response.data.data)
        if (response.data.data === 'Successfully updated CRF Form') {
          window.location.reload()
        }

        // this.setState({
        //     redirect: true,
        //     crfId: `/CheckRequest/${this.props.crfId}`
        //   })
        // console.log(this.state.redirect)
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  handleRemoveProjectClass = (e, index) => {
    e.preventDefault()
    const projectClass = [...this.state.projectClass]
    projectClass.splice(index, 1)
    let requestingGrossPrice = 0.0
    let requestingAmount = 0.0
    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice)
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount)
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2)
    })
  }

  localValidationProjectClasses = async (projectClasses, requestType) => {
    let validationRemarks = null
    let countIndex = 0
    for (const obj of projectClasses) {
      countIndex = countIndex + 1
      if (obj.glCategory === '') {
        alert(`Project class ${countIndex}: glCategory is required`)
        validationRemarks = 'Failed'
        break
      }
      // if (obj.glCategory === 'Advances') {
      //   if (!obj.projectClass) {
      //     alert(`Project class ${countIndex}: Project class is required`)
      //     validationRemarks = 'Failed'
      //     break
      //   }
      //   const { data } = await getData(
      //     `/api/projectClasses/${obj.projectClass}`
      //   )
      //   console.log(data)
      //   if (data === null) {
      //     alert(
      //       `Project class ${countIndex}: Please make sure that the project class is valid`
      //     )
      //     validationRemarks = 'Failed'
      //     break
      //   }
      // }
      if (obj.glAccount === '') {
        alert(`Project class ${countIndex}: glAccount is required`)
        validationRemarks = 'Failed'
        break
      }
      if (requestType === 'PO Item') {
        if (!obj.itemCode) {
          alert(`Project class ${countIndex}: itemNo is required`)
          validationRemarks = 'Failed'
          break
        }
        if (obj.itemCode) {
          const { data } = await getData(`/api/itemNo/${obj.itemCode}`)
          if (data === null) {
            alert(
              `Project class ${countIndex}: Please make sure that the item number is valid`
            )
            validationRemarks = 'Failed'
            break
          }
        }
      }
      if (obj.description1 === '') {
        alert(`Project class ${countIndex}: description 1 is required`)
        validationRemarks = 'Failed'
        break
      }
      if (obj.grossPricePerItem === 0) {
        alert(`Project class ${countIndex}: gross price is required`)
        validationRemarks = 'Failed'
        break
      }
      if (obj.vatType === '') {
        alert(`Project class ${countIndex}: vatType is required`)
        validationRemarks = 'Failed'
        break
      }
      if (obj.wTaxType === '') {
        alert(`Project class ${countIndex}: wTaxType is required`)
        validationRemarks = 'Failed'
        break
      }
    }
    return validationRemarks
  }

  handleSubmitDraft = async (e, key) => {
    e.preventDefault()
    this.setState({ isLoading: true })
    console.log(this.state.projectClass)
    let array = this.state.projectClass
    let formData = new FormData()
    const newProjectClass = []

    if (this.state.requestType === 'PO Item') {
      this.setState({ isLoading: true })
      // if(this.state.poNumber === null || this.state.poNumber === ""){
      //   document.getElementById('formHintContainer').style.display = "block"
      //   document.getElementById('draftErrorHint').innerText = "PO number is required."
      // }else{
      let nonPoForm = {
        // status: "For Approval",
        // vendor: this.state.vendor,
        // department: this.state.requestingDepartment,
        // particulars: this.state.particulars,
        // project: this.state.project,
        // subProject: this.state.subProject,
        // projectClasses: this.state.projectClass
        dueDate: this.state.dueDate,
        poNumber: this.state.poNumber,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        projectClasses: this.state.projectClass,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        status: 'For Approval'
      }
      const fieldToValidate = localValidation(nonPoForm)
      if (fieldToValidate !== null) {
        this.setState({ isLoading: false })
        alert(`${fieldToValidate} is required`)
        return 'remainOnFirstPage'
      } else {
        this.setState({ isLoading: false })
        const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`)
        const project = await getData(`/api/projects/${nonPoForm.project}`)
        console.log(nonPoForm.project)
        console.log(project)
        if (nonPoForm.poNumber.length !== 9 || nonPoForm.poNumber[0] !== '3') {
          alert('PO number must be 9 digits and should start with number 3')
          return 'remainOnFirstPage'
        }
        if (vendor.data === null) {
          alert('Please make sure that the vendor is valid')
          return 'remainOnFirstPage'
        }
        if (project.data === null) {
          alert('Please make sure that the project is valid')
          return 'remainOnFirstPage'
        }
        if (this.state.file === null || this.state.fileErr === 1) {
          const crf = await getData(`/api/checkRequestForm/${this.props.crfId}`)
          const { supportingDocuments } = crf.data
          if (!supportingDocuments) {
            alert('Supporting documents is required')
            return 'remainOnFirstPage'
          }
        }
        if (key === 'fromFirstPage') return
        const validationProjectClasses = await this.localValidationProjectClasses(
          nonPoForm.projectClasses,
          'PO Item'
        )
        if (validationProjectClasses) return
      }

      // to split glaccount string to get the accountCode
      for (const index in nonPoForm.projectClasses) {
        const glAccountArray = nonPoForm.projectClasses[index].glAccount.split(
          ' '
        )
        nonPoForm.projectClasses[index].glAccount = glAccountArray[0]
      }

      formData.set('crfForm', JSON.stringify(nonPoForm))
      formData.append('supportingDocuments', this.state.file)

      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.crfId}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
            isLoading: false,
            redirect: true,
            crfId: `/CheckRequest/${this.props.crfId}`
          })
          console.log(this.state.redirect)
          window.location.reload(false)
        })
        .catch(error => {
          this.setState({ isLoading: false })
          console.log(error.response)
          alert(error.response.data.Error)
          document.getElementById('formHintContainer').style.display = 'block'
          document.getElementById('draftErrorHint').innerText =
            ' ' +
            'Please make sure you filled up the required fields at Project Class' +
            ' ' +
            (parseInt(error.response.data.Error.slice(-1)) + 1)
          window.location.reload(false)
        })
      // }
    } else {
      this.setState({ isLoading: true })
      let nonPoForm = {
        // status: "For Approval",
        // vendor: this.state.vendor,
        // department: this.state.requestingDepartment,
        // particulars: this.state.particulars,
        // project: this.state.project,
        // subProject: this.state.subProject,
        // projectClasses: this.state.projectClass
        dueDate: this.state.dueDate,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        projectClasses: this.state.projectClass,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        status: 'For Approval'
      }

      const fieldToValidate = localValidation(nonPoForm)
      console.log(fieldToValidate)
      if (fieldToValidate !== null) {
        this.setState({ isLoading: false })
        alert(`${fieldToValidate} is required`)
        return 'remainOnFirstPage'
      } else {
        this.setState({ isLoading: false })
        const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`)
        const project = await getData(`/api/projects/${nonPoForm.project}`)
        if (vendor.data === null) {
          alert('Please make sure that the vendor is valid')
          return 'remainOnFirstPage'
        }
        if (project.data === null) {
          alert('Please make sure that the project is valid')
          return 'remainOnFirstPage'
        }
        if (this.state.file === null || this.state.fileErr === 1) {
          const crf = await getData(`/api/checkRequestForm/${this.props.crfId}`)
          const { supportingDocuments } = crf.data
          if (!supportingDocuments) {
            alert('Supporting documents is required')
            return 'remainOnFirstPage'
          }
        }
        if (key === 'fromFirstPage') return
        const validationProjectClasses = await this.localValidationProjectClasses(
          nonPoForm.projectClasses,
          'Non PO Item'
        )
        if (validationProjectClasses) return
      }

      // to split glaccount string to get the accountCode
      for (const index in nonPoForm.projectClasses) {
        const glAccountArray = nonPoForm.projectClasses[index].glAccount.split(
          ' '
        )
        nonPoForm.projectClasses[index].glAccount = glAccountArray[0]
      }

      formData.set('crfForm', JSON.stringify(nonPoForm))
      formData.append('supportingDocuments', this.state.file)
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.crfId}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
            isLoading: false,
            redirect: true,
            crfId: `/CheckRequest/${this.props.crfId}`
          })
          console.log(this.state.redirect)
          window.location.reload(false)
        })
        .catch(error => {
          this.setState({ isLoading: false })
          alert('Server Error')
          console.log(error.response.data.Error)
          if (error.response.data.Error === 'projectClass code doesnt exist') {
            document.getElementById('formHintContainer').style.display = 'block'
            document.getElementById('draftErrorHint').innerText =
              'You have inputed an invalid Project Class value.'
          }
          window.location.reload(false)
        })
    }
  }

  handleDownloadPdf = () => {
    axios(`${process.env.REACT_APP_API_KEY}/api/uploads/${this.props.crfId}`, {
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
      //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], {
          type: 'application/pdf'
        })
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file)
        //Open the URL on new Window
        window.open(fileURL)
      })
      .catch(error => {
        console.log(error)
      })
  }

  render () {
    console.log(this.state.projectClass)

    let vatTypeSelections = ''
    // if (this.state.vatTypeSelector == '') {
    vatTypeSelections = (
      <>
        {/* <option value="" disabled selected hidden>Please Choose...</option> */}
        <option value='IVAT-S'>IVAT-S</option>
        <option value='DIV-S'>DIV-S</option>
        <option value='DIV-R'>DIV-R</option>
        <option value='DIV-L'>DIV-L</option>
        <option value='VAT-X'>VAT-X</option>
        <option value='VAT-Z'>VAT-Z</option>
        <option value='NON-VAT'>NON-VAT</option>
        <option value='INT-IV'>INT-IV</option>
      </>
    )
    // }
    // else if (this.state.vatTypeSelector == 'IVAT-G') {
    //   vatTypeSelections = (
    //     <>
    //       {/* <option value="" disabled selected hidden>Please Choose...</option> */}
    //       <option value='None IVAT-X1'>None IVAT-X1</option>
    //       <option value='Goods IVAT-G'>Goods IVAT-G</option>
    //     </>
    //   )
    //   // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   //   this.state.projectClass[i].vatType = "Goods IVAT-G"
    //   // }
    //   // console.log(this.state.projectClass)
    // } else if (this.state.vatTypeSelector == 'IVAT-S') {
    //   vatTypeSelections = (
    //     <>
    //       {/* <option value="" disabled selected hidden>Please Choose...</option> */}
    //       <option value='None IVAT-X1'>None IVAT-X1</option>
    //       <option value='Services IVAT-S'>Services IVAT-S</option>
    //     </>
    //   )
    //   // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   //   this.state.projectClass[i].vatType = "Services IVAT-S"
    //   // }
    //   // console.log(this.state.projectClass)
    // } else if (this.state.vatTypeSelector == 'X1') {
    //   vatTypeSelections = (
    //     <>
    //       <option value='None IVAT-X1'>None IVAT-X1</option>
    //     </>
    //   )
    //   for (let i = 0; i < this.state.projectClass.length; i++) {
    //     this.state.projectClass[i].vatType = 'None IVAT-X1'
    //   }
    //   // console.log(this.state.projectClass)
    // }
    if (this.state.redirect === true) {
      return <Redirect to={this.state.crfId} />
    }
    console.log(this.state.isLoading)
    return (
      <CrfContext.Consumer>
        {context => (
          <form id='mainPage'>
            <PoModal />
            <div id='mainPanel'>
              <div className='formContainer'>
                <Transition
                  native
                  items={this.state.showForm}
                  from={{ opacity: 0 }}
                  enter={{ opacity: 1 }}
                  leave={{ opacity: 0 }}
                  config={{ duration: 300 }}
                >
                  {show =>
                    show &&
                    (props => (
                      <animated.div style={props}>
                        <DraftView
                          projectClassAdvances={this.state.projectClassAdvances}
                          projectClassCocExpenses={
                            this.state.projectClassCocExpenses
                          }
                          dueDate={this.state.dueDate}
                          isLoading={this.state.isLoading}
                          requestingGrossPrice={this.state.requestingGrossPrice}
                          requestingAmount={this.state.requestingAmount}
                          handleDownloadPdf={this.handleDownloadPdf}
                          requestType={this.state.requestType}
                          fileText={this.state.fileText}
                          cocExpenses={this.state.cocExpenses}
                          advances={this.state.advances}
                          ppeAccounts={this.state.ppeAccounts}
                          adminExpenses={this.state.adminExpenses}
                          opex={this.state.opex}
                          advancesProjectClass={this.state.advancesProjectClass}
                          userDeptList={this.state.userDeptList}
                          requestingDepartment={this.state.requestingDepartment}
                          poNumber={this.state.poNumber}
                          vendor={this.state.vendor}
                          vendorError={this.state.vendorError}
                          vendorErr={this.state.vendorErr}
                          particulars={this.state.particulars}
                          particularsError={this.state.particularsError}
                          particularsErr={this.state.particularsErr}
                          project={this.state.project}
                          projectError={this.state.projectError}
                          projectErr={this.state.projectErr}
                          file={this.state.file}
                          fileError={this.state.fileError}
                          fileErr={this.state.fileErr}
                          subProject={this.state.subProject}
                          projectClass={this.state.projectClass}
                          accountTypes={this.state.accountTypes}
                          vatTypeSelector={this.state.vatTypeSelector}
                          vatTypeSelections={vatTypeSelections}
                          wTaxRates={this.state.wTaxRates}
                          handleChangeRequestField={
                            this.handleChangeRequestField
                          }
                          handleChangeProjectClassValue={
                            this.handleChangeProjectClassValue
                          }
                          addProjectClass={this.addProjectClass}
                          handleSubmitNonPo={this.handleSubmitNonPo}
                          handleDraftNonPo={this.handleDraftNonPo}
                          checkStateValue={this.checkStateValue}
                          file={this.state.file}
                          vendorLists={this.state.vendorLists}
                          projectLists={this.state.projectLists}
                          //this is
                          requestId={this.state.requestId}
                          //
                          handleRemoveProjectClass={
                            this.handleRemoveProjectClass
                          }
                          addedProjectClass={this.state.addedProjectClass}
                          changed={this.onChangedHandler}
                          onBlurNumber={this.onBlurNumber}
                          handleSubmitDraft={this.handleSubmitDraft}
                          isProject={context.state.isProject}
                        />
                      </animated.div>
                    ))
                  }
                </Transition>
              </div>
              {/* END OF FORM */}
            </div>
          </form>
        )}
      </CrfContext.Consumer>
    )
  }
}

const dark = {
  color: 'black'
}

export default NonPoItems
